import { Box, Flex } from '@chakra-ui/react';

import { DownloadIcon } from 'Asset/icon';
import SearchComponent from 'UiKit/search';
import ButtonSolid from 'UiKit/button/buttonSolid';
import { TextRegular, TextSemiBold } from 'UiKit/typography';
import { reportHelpPartnerText } from 'Const/report-help-partner/view';
import FilterSelect from 'UiKit/filter-select';
import FilterDatepicker from 'UiKit/filter-datepicker';
import useGetStudioList from 'Domain/report-help-partner/useGetStudioList';

import { useReportHelpPartnerState } from 'View/report-help-partner/state/index';

import styles from './styles.module.css';
import useExportGetReportHelpPartner from 'Domain/report-help-partner/useExportGetReportHelpPartner';

const Filter = ({ t }) => {
  const { filterState, updateFilterState } = useReportHelpPartnerState();

  const { data: studioOptions, isFetching: isFetchingStudio } = useGetStudioList();
  const { mutate: exportReport } = useExportGetReportHelpPartner();

  const handleFilter = ({ field, value }) => {
    updateFilterState({
      page: 1,
      [field]: value,
    });
  };

  const handleExport = () => {
    exportReport(filterState);
  };

  return (
    <Box className={styles['filter__container']} data-testid="filter">
      <Box className={styles['filter__field--container']}>
        <SearchComponent
          width="377px"
          value={filterState?.search}
          debounceTime={600}
          onSearch={(search) => handleFilter({ field: 'search', value: search })}
        />
        <Box>
          <FilterSelect
            placeholder={t('filter.selectRoom')}
            width="200px"
            isMulti={false}
            value={filterState?.studioId}
            clearable={true}
            onChange={(studioId) => handleFilter({ field: 'studioId', value: studioId })}
            options={studioOptions}
            isLoading={isFetchingStudio}
          />
        </Box>
        <Flex alignItems={'center'} gap={'6px'}>
          <FilterDatepicker
            placeholder={t('filter.startDate')}
            value={filterState?.startedAt}
            onChange={(startedAt) => handleFilter({ field: 'startedAt', value: startedAt })}
          />
          <TextRegular>-</TextRegular>
          <FilterDatepicker
            placeholder={t('filter.endDate')}
            value={filterState?.endedAt}
            onChange={(endedAt) => handleFilter({ field: 'endedAt', value: endedAt })}
          />
        </Flex>
      </Box>
      <Box>
        <ButtonSolid className={styles['filter__button-export']} onClick={handleExport}>
          <DownloadIcon size="14px" /> <TextSemiBold className={styles['filter_button-export--text']}>{reportHelpPartnerText.buttonExportText}</TextSemiBold>
        </ButtonSolid>
      </Box>
    </Box>
  );
};

export default Filter;
